module.exports = __webpack_public_path__ + "img/photo-0059.50492349.jpg";